import type { ValueFormatterParams } from 'ag-grid-community'

export const eligibilityFormatter = (params: ValueFormatterParams): string => {
  if (params.data?.EeEligibility === 'Yes') {
    return `*${params.value}`
  }

  return params.value
}
